import { ObserveVisibility } from 'vue-observe-visibility';
import config from '@/config';

// Notifications
import OrderReceived from '@/components/notifications/components/OrderReceived.notification.vue';
import NotifyFirms from '@/components/notifications/components/NotifyFirms.notification.vue';
import TrialEndsSoon from '@/components/notifications/components/TrialEndsSoon.notification.vue';
import TrialEnded from '@/components/notifications/components/TrialEnded.notification.vue';
import FirmCreated from '@/components/notifications/components/FirmCreated.notification.vue';
import BalanceReplenish from '@/components/notifications/components/BalanceReplenish.notification.vue';
import PackageActivated from '@/components/notifications/components/PackageActivated.notification.vue';
import PackageEndsSoon from '@/components/notifications/components/PackageEndsSoon.notification.vue';
import PackageEnded from '@/components/notifications/components/PackageEnded.notification.vue';
import PackageEndedDaysBack from '@/components/notifications/components/PackageEndedDaysBack.notification.vue';
import OrderNotRead from '@/components/notifications/components/OrderNotRead.notification.vue';
import OrderAssemblyComes from '@/components/notifications/components/OrderAssemblyComes.notification.vue';
import ConstructorNotConfigured from '@/components/notifications/components/ConstructorNotConfigured.notification.vue';
import LazyLoader from '../../ui/LazyLoader/LazyLoader';

export default {
  data() {
    return {
      rootElement: null
    };
  },

  props: {
    sortedNotifications: Object,
    notificationsPage: Number,
    notificationsCount: Number,
    isNotificationsLoading: Boolean
  },

  methods: {
    updateNotifications() {
      if (this.notificationsPage !== 0) {
        this.$store.dispatch('getNotifications');
      }
    },

    notificationVisible(isVisible, _entry, notification) {
      if (isVisible && !notification.viewed) {
        this.$store.dispatch('setViewedToNotification', {
          id: notification.id,
          viewed: true
        });
      }
    },

    toCamelCase(type) {
      return type
        .replace(/[^_]+/g, substring => {
          return (
            substring.charAt(0).toUpperCase() +
            substring.substr(1).toLowerCase()
          );
        })
        .replace(/_/g, '');
    },

    onClickNotificationLink() {
      this.$emit('clickLink');
    }
  },

  mounted() {
    this.rootElement = this.$parent.$el.children[1];
  },

  destroyed() {
    if (this.notificationsCount > config.websocketNotifications.perPage) {
      this.$store.dispatch('resetNotification');
      this.$store.dispatch('getNotifications');
    }
  },

  directives: {
    ObserveVisibility
  },

  components: {
    OrderReceived,
    NotifyFirms,
    TrialEndsSoon,
    TrialEnded,
    FirmCreated,
    BalanceReplenish,
    PackageActivated,
    PackageEndsSoon,
    PackageEnded,
    PackageEndedDaysBack,
    OrderNotRead,
    OrderAssemblyComes,
    ConstructorNotConfigured,
    LazyLoader
  }
};
